<template>
  <div class="app-container setting">
    <div>
      <el-tabs class="setting-tab" tab-position="left" type="card" v-model="tabName" @tab-click="handleClick">
        <!-- <el-tab-pane label="用户账号设置" name="account"></el-tab-pane> -->
        <el-tab-pane label="订单标记设置" name="marker"></el-tab-pane>
        <el-tab-pane label="发货地址设置" name="address"></el-tab-pane>
        <!-- <el-tab-pane label="快递模板设置" name="templete"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="setting-content">
      <account-tab ref="accountTab" v-if="tabName == 'account'" />
      <marker-tab ref="markerTab" v-if="tabName == 'marker'" />
      <address-tab ref="addressTab" v-if="tabName == 'address'" />
      <templete-tab ref="templeteTab" v-if="tabName == 'templete'" />
    </div>
  </div>
</template>
<script>
import accountTab from "@/components/setting/accountTab/index";
import markerTab from "@/components/setting/markerTab/index";
import addressTab from "@/components/setting/addressTab/index";
import templeteTab from "@/components/setting/templeteTab/index";

export default {
  name: "printandship",
  components: { accountTab, markerTab, addressTab, templeteTab },
  data() {
    return {
      tabName: "marker"
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$refs[this.tabName + "Tab"].getData()
    },
    handleClick(e) {
      this.$nextTick(() => {
        this.getData();
      });
    },
  }
}
</script>
<style lang="scss">
.setting {
  display: flex;

  .setting-tab {
    .el-tabs__nav {
      border-bottom: none !important;
    }
  }

  .setting-content {
    margin-left: 20px;
    width: calc(100% - 155px);
  }
}
</style>